export const translations = {
	'Change incident status...': {
		no: 'Endre status',
	},
	'Reporter can not set private comment': {
		no: 'Eier (Rapportert av) kan ikke sette privat kommentar',
	},
	'Comment is empty. Please type in a comment for this incident.': {
		no: 'Kommentarfeltet er tomt. Skriv inn kommentar for denne saken.',
	},
	'Comment successfully added': {
		no: 'Kommentar er opprettet',
	},
	'Comment successfully updated': {
		no: 'Kommentar er oppdatert',
	},
	'Services selected assets belong to': {
		no: 'Tjenestene som valgte ressurser er tilknyttet',
	},
	'Incident is not valid as the service is deleted from account.': {
		no: 'sak er ikke gyldig da tjeneste er slettet.',
	},
	'Assign incident to user': {
		no: 'Velg bruker for sak',
	},
	'Select owner for incident': {
		no: 'Velg eier for sak',
	},
	'Select status for incident': {
		no: 'Velg status for sak',
	},
	'Select healthreason for incident': {
		no: 'Velg helseårsak for sak',
	},
	'input subject message': {
		no: 'Skriv inn tittel for sak',
	},
	'Incident successfully created': {
		no: 'Sak er opprettet',
	},
	'Incident successfully updated': {
		no: 'Sak er oppdatert',
	},
	'Add comment': {
		no: 'Legg til kommentar',
	},
	'Edit comment': {
		no: 'Oppdater kommentar',
	},
	'Delete comment': {
		no: 'Slett kommentar',
	},
	'Comment successfully deleted': {
		no: 'Kommentar er slettet',
	},
};
